// extracted by mini-css-extract-plugin
export default {"center":"Button_center__+l5LB","button":"Button_button__jz1FI","shine":"Button_shine__z8YRN"};